import { getData, postData } from "../apiClient";

export const GetAlRoomsTypeList = async () => {
    try {
        const result = await getData(`/room-assign/get-room-lists`);
        return {
            data: {
                success: true,
                ...result,
            },
        };
    } catch (error) {
        console.error("Get All Room List API Error:", error);
        return {
            data: {
                success: false,
                error: error.status === 400 ? error.error : error.message,
                status: error.status,
            },
        };
    }
};

export const GetAllRoomsWithFloor = async () => {
    try {
        const result = await getData(`/room-assign/get-floor-room`);
        return {
            data: {
                success: true,
                ...result,
            },
        };
    } catch (error) {
        console.error("Get All Room List API Error:", error);
        return {
            data: {
                success: false,
                error: error.status === 400 ? error.error : error.message,
                status: error.status,
            },
        };
    }
}

export const GetAllRoomsIdList = async (id) => {
    try {
        const result = await getData(`/room-assign/${id}`);
        return {
            data: {
                success: true,
                ...result,
            },
        };
    } catch (error) {
        console.error("Get All Room List API Error:", error);
        return {
            data: {
                success: false,
                error: error.status === 400 ? error.error : error.message,
                status: error.status,
            },
        };
    }
}

export const AssignRoomType = async (data) => {
    try {
        const result = await postData(`/room-assign/`, data);
        return {
            data: {
                success: true,
                data: result,
            },
        };
    } catch (error) {
        console.error("Assign Room Type API Error:", error);
        return {
            data: {
                success: false,
                error: error.status === 400 ? error.error : error.message,
                status: error.status,
            },
        };
    }
}